import bellSvg from '../../../../../assets/icons/bell.svg';
import './NotificationCounter.scss';

export type NotificationCounterProps = {
  count?: number;
  onButtonClick?: () => void;
  showContent?: boolean;
};

export const NotificationCounter = ({
  count = 0,
  onButtonClick,
}: NotificationCounterProps) => {
  return (
    <div className="notification-counter">
      <button
        type="button"
        className="notification-counter__icon"
        onClick={onButtonClick}
        aria-label="conversations"
      >
        <img src={bellSvg} className="notification-counter__bell" alt="" />
        {count > 0 && (
          <span className="notification-counter__badge">{count}</span>
        )}
      </button>
    </div>
  );
};

export default NotificationCounter;
